import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import AOS from 'aos';
import 'aos/dist/aos.css';

const Galerie = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);
  const category = "clublespins";

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      mirror: false
    });

    const fetchImages = async () => {
      try {
        setFadeOut(true);
        
        const { data, error } = await supabase
          .from("category_images")
          .select("id, url, category")
          .eq("category", category);

        if (error) throw error;

        setImages(data);
        
        setTimeout(() => {
          setFadeOut(false);
        }, 300);
        
      } catch (err) {
        console.error("Erreur de chargement des images :", err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchImages();
  }, []);

  return (
    <>
      <div 
        className="bradcam_area breadcam_bg_2"
        data-aos="fade-down"
        data-aos-delay="200"
      >
        <h3>Gallery</h3>
      </div>

      <div 
        className="section-top-border" 
        style={{
          opacity: fadeOut ? 0 : 1,
          transition: 'opacity 0.5s ease-in-out'
        }}
      >
        <div className="gallery-header text-center mb-5">
          <div className="section-divider">
            <span className="divider-line"></span>
            <h3 className="gallery-title">
              <span className="title-text">Image Gallery</span>
              <span className="title-underline"></span>
            </h3>
            <span className="divider-line"></span>
          </div>
          <p className="gallery-subtitle mt-3">
            Discover the beauty of Club Les Pins through our curated collection
          </p>
        </div>

        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading images...</span>
            </div>
            <p className="mt-3 text-muted">Loading images...</p>
          </div>
        ) : images.length === 0 ? (
          <div className="text-center py-5">
            <div className="empty-gallery">
              <i className="fa fa-image fa-3x text-muted mb-3"></i>
              <p className="text-muted">No images available for the gallery.</p>
            </div>
          </div>
        ) : (
          <div className="row gallery-item">
            {images.map((image, index) => (
              <div 
                className="col-md-4 mb-4" 
                key={image.id}
              >
                <a href={image.url} className="img-pop-up gallery-image-link">
                  <div 
                    className="single-gallery-image" 
                    style={{
                      background: `url(${image.url})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      height: '300px',
                      width: '100%',
                      transition: 'all 0.4s ease',
                      borderRadius: '12px',
                      position: 'relative',
                      overflow: 'hidden'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'scale(1.05)';
                      e.currentTarget.style.boxShadow = '0 15px 30px rgba(0,0,0,0.3)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'scale(1)';
                      e.currentTarget.style.boxShadow = '0 5px 15px rgba(0,0,0,0.2)';
                    }}
                  >
                    <div 
                      className="image-overlay"
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'rgba(0,0,0,0.3)',
                        opacity: 0,
                        transition: 'opacity 0.3s ease',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <i 
                        className="fa fa-search-plus text-white"
                        style={{
                          fontSize: '2rem',
                          transform: 'scale(0.8)',
                          transition: 'transform 0.3s ease'
                        }}
                      ></i>
                    </div>
                  </div>
                </a>
              </div>
            ))}
          </div>
        )}
      </div>
    
      <div className="instragram_area">
        {[1, 2, 3, 4, 5].map((item, index) => (
          <div 
            className="single_instagram" 
            key={index}
          >
            <img src={`assets/img/instragram/${item}.png`} alt=""/>
            <div className="ovrelay">
              <a href="#">
                <i className="fa fa-instagram"></i>
              </a>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Galerie;